import React from 'react';

export default (
    <div className={"powered-by"}>
        Powered by <img className={"powered-by__img"} src={"/images/vxlogo.svg"} alt="VISIT-X" />
    </div>
);
